module.exports = __webpack_public_path__ + "img/create-2.f69a0702.png";